import { DEFAULT_LANGUAGE, SITE_NAME } from '../config/constants';

export function getLanguageByPath(path, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

export function getDocumentTitle(title) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

export function getEmbedMediaURL(source) {
  const patterns = {
    youtube: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
    vimeo: /^https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)$/,
  };

  let match;
  let domain;
  // eslint-disable-next-line no-restricted-syntax
  for (const key in patterns) {
    match = patterns[key].exec(source);
    if (match) {
      domain = key;
      break;
    }
  }

  if (!match) return false;

  const vid = match[1];
  switch (domain.toLowerCase()) {
    case 'vimeo':
      return `https://player.vimeo.com/video/${vid}`;

    case 'youtube':
      return `https://www.youtube.com/embed/${vid}`;

    default:
      return false;
  }
}

export function formatTwoDecimals(amount) {
  const currencyFormatter = new Intl.NumberFormat(
    'nl-NL',
    {
      minimumSignificantDigits: 2,
      maximumSignificantDigits: 3,
    },
  );
  return currencyFormatter.format(amount);
}

export function formatDiscount(amount) {
  // we need to turn -0.1 into 0,10
  const twoDecimals = formatTwoDecimals(amount * -1);

  // Then we can prepend the Euro. Because discount is written as -€0,10 and not €-0,10
  return `- €${twoDecimals}`;
}
